//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectBodyList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AttributeType",1,0],[0,"ChannelColor",1,0],[0,"ChannelType",1,0],[1,"Channels",0,"SelectBodyList",0],[0,"Layer",1,0]],[[["redValue","greenValue","blueValue"],"GetChannelColor",{},0,1],[["redValue","greenValue","blueValue"],"SetChannelColor",{},3,1],[["modified"],"SetColorModified",{},1,0]],[]];
SPLM.Tooling.SpecifyBaffleBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.SpecifyBaffleBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.SpecifyBaffleBuilder.AttributeTypes = Object.freeze({
    "BodyAsChannel" : "BodyAsChannel", "BodyAsBaffle" : "BodyAsBaffle"});

export default SPLM;